import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';

const config = require('../../config.json');
  
export default function ImageDisplay(props) {
    const { galleryImages, titleName, subTitleName, handleDeleteImage, handleOpen } = props;  
    
    return (
      <div className="image-display-section animate-fade-in-up">
        <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
          <div>
            <h5 className="fw-bold mb-0 text-primary">{titleName || "Slider Images"}</h5>
            <span className="text-muted small">{subTitleName || "Manage active images on the college website"}</span>
          </div>
          <Button 
            variant="primary" 
            size="sm"
            onClick={handleOpen}
            className="d-inline-flex align-items-center gap-2"
          >
            <i className="fa fa-plus"></i> Add New Image
          </Button>
        </div>

        {galleryImages && galleryImages.length > 0 ? (
          <Row className="g-4">
            {galleryImages.map((item, index) => (
              <Col xs={12} sm={6} md={4} lg={3} key={index}>
                <Card className="h-100 shadow-sm overflow-hidden p-0 border" style={{ borderRadius: '16px' }}>
                  <div style={{ height: '180px', overflow: 'hidden', position: 'relative' }}>
                    <Card.Img 
                      variant="top" 
                      src={`${config.s3.invokeURL}${item.fullPathName}`} 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=400&q=80";
                      }}
                    />
                  </div>
                  <Card.Footer className="bg-white border-top p-3 d-flex justify-content-between align-items-center">
                    <span className="small text-muted text-truncate" style={{ maxWidth: '140px' }}>
                      {item.fileName || `Image ${index + 1}`}
                    </span>
                    <button 
                      className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1 rounded-pill px-3"
                      onClick={(event) => handleDeleteImage(event, item.fullPathName)}
                      title="Delete image"
                    >
                      <i className="fa fa-trash-o"></i> Delete
                    </button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="card p-5 text-center shadow-sm">
            <i className="fa fa-picture-o fa-3x text-muted mb-3"></i>
            <h5 className="fw-bold">No Images Uploaded</h5>
            <p className="text-muted small">Click "Add New Image" above to upload photos to this section.</p>
          </div>
        )}
      </div>
    );
}